import {
  IEntertainmentEventTicketType,
  IEntertainmentPerformance,
} from '@shared/shared/interfaces/entertainment-event.interfaces';
import * as entertainmentEventTicketTypeActions from '../actions/entertainment-event-ticket-type.actions';

export interface EntertainmentEventTicketType extends IEntertainmentEventTicketType {
  loaded: boolean;
  loading: boolean;
}

export const initialState: EntertainmentEventTicketType = {
  description: '',
  expectations: '',
  face_price: '',
  face_price_currency: '',
  going_on_sale: '',
  id: 0,
  max_available_tickets_per_member: 0,
  min_available_tickets_per_member: 0,
  performance: {} as IEntertainmentPerformance,
  price: '',
  price_currency: '',
  provider: '',
  section: '',
  status: '',
  total_ticket: 0,
  url: '',
  loading: false,
  loaded: false,
};

export function reducer(
  state = initialState,
  action: entertainmentEventTicketTypeActions.EntertainmentEventTicketTypeAction
): EntertainmentEventTicketType {
  switch (action.type) {
    case entertainmentEventTicketTypeActions.GET_ENTERTAINMENT_TICKET_TYPE: {
      return {
        ...state,
        loading: true,
      };
    }

    case entertainmentEventTicketTypeActions.GET_ENTERTAINMENT_TICKET_TYPE_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        loading: false,
        loaded: true,
      };
    }

    case entertainmentEventTicketTypeActions.GET_ENTERTAINMENT_TICKET_TYPE_FAIL: {
      return {
        ...state,
        loading: false,
        loaded: false,
      };
    }
    default:
      return state;
  }
}
